
import React from 'react';
import { Route, Navigate } from 'react-router-dom';
import HQDashboard from '@/pages/hq/HQDashboard';
import HQStudios from '@/pages/hq/HQStudios';
import HQStaff from '@/pages/hq/HQStaff';
import HQTraining from '@/pages/hq/HQTraining';
import HQMetrics from '@/pages/hq/HQMetrics';
import HQTasks from '@/pages/hq/HQTasks';
import HQChecklists from '@/pages/hq/HQChecklists';
import HQSOPs from '@/pages/operations/HQSOPs';
import HQKits from '@/pages/hq/HQKits';
import LaunchKit from '@/pages/hq/kits/LaunchKit';
import TrainingKit from '@/pages/hq/kits/TrainingKit';
import MarketingKit from '@/pages/hq/kits/MarketingKit';
import ComplianceKit from '@/pages/hq/kits/ComplianceKit';
import TechnologyKit from '@/pages/hq/kits/TechnologyKit';
import HQAgents from '@/pages/hq/HQAgents';
import HQSupport from '@/pages/hq/HQSupport';
import HQLogs from '@/pages/hq/HQLogs';
import HQIntegrations from '@/pages/hq/HQIntegrations';
import RoleProtectedRoute from '@/components/RoleProtectedRoute';

export const HQRoutes = () => (
  <>
    {/* Main HQ Dashboard */}
    <Route 
      path="/hq" 
      element={
        <RoleProtectedRoute allowedRoles={['admin']}>
          <HQDashboard />
        </RoleProtectedRoute>
      } 
    />
    <Route 
      path="/hq/dashboard" 
      element={
        <RoleProtectedRoute allowedRoles={['admin']}>
          <HQDashboard />
        </RoleProtectedRoute>
      } 
    />

    {/* Studios (formerly Locations) */}
    <Route 
      path="/hq/studios" 
      element={
        <RoleProtectedRoute allowedRoles={['admin']}>
          <HQStudios />
        </RoleProtectedRoute>
      } 
    />

    {/* Staff Management */}
    <Route 
      path="/hq/staff" 
      element={
        <RoleProtectedRoute allowedRoles={['admin']}>
          <HQStaff />
        </RoleProtectedRoute>
      } 
    />

    {/* Training System */}
    <Route 
      path="/hq/training" 
      element={
        <RoleProtectedRoute allowedRoles={['admin']}>
          <HQTraining />
        </RoleProtectedRoute>
      } 
    />

    {/* Metrics & KPIs */}
    <Route 
      path="/hq/metrics" 
      element={
        <RoleProtectedRoute allowedRoles={['admin']}>
          <HQMetrics />
        </RoleProtectedRoute>
      } 
    />

    {/* Task Management */}
    <Route 
      path="/hq/tasks" 
      element={
        <RoleProtectedRoute allowedRoles={['admin']}>
          <HQTasks />
        </RoleProtectedRoute>
      } 
    />

    {/* Launch Checklists */}
    <Route 
      path="/hq/checklists" 
      element={
        <RoleProtectedRoute allowedRoles={['admin']}>
          <HQChecklists />
        </RoleProtectedRoute>
      } 
    />

    {/* SOP Library */}
    <Route 
      path="/hq/sops" 
      element={
        <RoleProtectedRoute allowedRoles={['admin']}>
          <HQSOPs />
        </RoleProtectedRoute>
      } 
    />
    <Route 
      path="/hq/sops/:category" 
      element={
        <RoleProtectedRoute allowedRoles={['admin']}>
          <HQSOPs />
        </RoleProtectedRoute>
      } 
    />
    <Route 
      path="/hq/sops/:category/:docId" 
      element={
        <RoleProtectedRoute allowedRoles={['admin']}>
          <HQSOPs />
        </RoleProtectedRoute>
      } 
    />
    <Route 
      path="/hq/sops/new" 
      element={
        <RoleProtectedRoute allowedRoles={['admin']}>
          <HQSOPs />
        </RoleProtectedRoute>
      } 
    />

    {/* Launch Kits */}
    <Route 
      path="/hq/kits" 
      element={
        <RoleProtectedRoute allowedRoles={['admin']}>
          <HQKits />
        </RoleProtectedRoute>
      } 
    />

    {/* Individual Kit Pages */}
    <Route 
      path="/hq/kits/launch" 
      element={
        <RoleProtectedRoute allowedRoles={['admin']}>
          <LaunchKit />
        </RoleProtectedRoute>
      } 
    />
    <Route 
      path="/hq/kits/training" 
      element={
        <RoleProtectedRoute allowedRoles={['admin']}>
          <TrainingKit />
        </RoleProtectedRoute>
      } 
    />
    <Route 
      path="/hq/kits/marketing" 
      element={
        <RoleProtectedRoute allowedRoles={['admin']}>
          <MarketingKit />
        </RoleProtectedRoute>
      } 
    />
    <Route 
      path="/hq/kits/compliance" 
      element={
        <RoleProtectedRoute allowedRoles={['admin']}>
          <ComplianceKit />
        </RoleProtectedRoute>
      } 
    />
    <Route 
      path="/hq/kits/technology" 
      element={
        <RoleProtectedRoute allowedRoles={['admin']}>
          <TechnologyKit />
        </RoleProtectedRoute>
      } 
    />

    {/* AI Agents */}
    <Route 
      path="/hq/agents" 
      element={
        <RoleProtectedRoute allowedRoles={['admin']}>
          <HQAgents />
        </RoleProtectedRoute>
      } 
    />

    {/* Support */}
    <Route 
      path="/hq/support" 
      element={
        <RoleProtectedRoute allowedRoles={['admin']}>
          <HQSupport />
        </RoleProtectedRoute>
      } 
    />

    {/* System Logs */}
    <Route 
      path="/hq/logs" 
      element={
        <RoleProtectedRoute allowedRoles={['admin']}>
          <HQLogs />
        </RoleProtectedRoute>
      } 
    />

    {/* Integrations */}
    <Route 
      path="/hq/integrations" 
      element={
        <RoleProtectedRoute allowedRoles={['admin']}>
          <HQIntegrations />
        </RoleProtectedRoute>
      } 
    />
  </>
);
